'use strict';

module.exports = require('./Tooltip');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.3.4.2@rc-tooltip/lib/index.js
 ** module id = 506
 ** module chunks = 0 1
 **/